import { all, call, put, select } from 'redux-saga/effects';
import { scheduleActions } from '../../actions';
import { fetchTimelineEntries } from './fetchTimelineEntries';
import { CrewTimelineEntryType } from '../../../../../../../common/types/timeline/CrewTimelineEntryType';
import { AircraftTimelineEntryType } from '../../../../../../../common/types/timeline/AircraftTimelineEntryType';
import { selectCompanySettingsSaga } from '../../../../../../../common/saga/selectors';
import { ContractTimelineEntryType } from '../../../../../../../common/types/timeline/ContractTimelineEntryType';
import { MaintenanceTimelineEntryType } from '../../../../../../../common/types/timeline/MaintenanceTimelineEntryType';
import { getVisibleTimelinePeriod } from '../../selectors';
import { TimelinePeriod } from '../../../types/TimelinePeriod';
import moment from 'moment';
import { fetchExtensionPeriodEntries } from './fetchExtensionEntries';

export function* fetchAllEntries() {
  yield put(
    scheduleActions.setState({
      isShowTimelineLoaded: true,
      allEntryTypesLoaded: false,
      isLoadingEntriesQuietly: true,
    }),
  );

  // const timePeriod = yield* selectSelectedTimelinePeriodSaga();

  const visibleTimelinePeriod = yield select(getVisibleTimelinePeriod);
  const timePeriod = new TimelinePeriod(
    moment(visibleTimelinePeriod.start)
      .subtract(4, 'month')
      .startOf('month')
      .startOf('day'),
    moment(visibleTimelinePeriod.end)
      .add(4, 'month')
      .endOf('month')
      .endOf('day'),
  );

  yield put(scheduleActions.setTimelineBufferPeriod(timePeriod));

  yield call(loadAll, timePeriod.getStart().format(), timePeriod.getEnd().format());
  yield put(
    scheduleActions.setState({
      allEntryTypesLoaded: true,
      isShowTimelineLoaded: false,
      isLoadingEntriesQuietly: false,
      loadedTimelineBufferPeriod: timePeriod,
    }),
  );
}

export function* loadAll(
  from: string,
  to: string,
  append: string = 'none',
  referenceDate: number = 0,
) {
  const companySettings = yield* selectCompanySettingsSaga();

  const calls = [
    call(
      fetchTimelineEntries,
      from,
      to,
      CrewTimelineEntryType.PilotContract,
      append,
      referenceDate,
    ),
    call(fetchTimelineEntries, from, to, CrewTimelineEntryType.DutyTimes, append, referenceDate),
    call(fetchTimelineEntries, from, to, CrewTimelineEntryType.DutySchedule, append, referenceDate),
    call(fetchTimelineEntries, from, to, CrewTimelineEntryType.CrewSchedule, append, referenceDate),
    call(
      fetchTimelineEntries,
      from,
      to,
      AircraftTimelineEntryType.AircraftSchedule,
      append,
      referenceDate,
    ),
    call(
      fetchTimelineEntries,
      from,
      to,
      AircraftTimelineEntryType.MaintenanceAircraftSchedule,
      append,
      referenceDate,
    ),
    call(
      fetchTimelineEntries,
      from,
      to,
      AircraftTimelineEntryType.AircraftContract,
      append,
      referenceDate,
    ),
    call(
      fetchTimelineEntries,
      from,
      to,
      MaintenanceTimelineEntryType.MaintenanceCrew,
      append,
      referenceDate,
    ),
  ];

  if (companySettings.ContractSchedule) {
    calls.push(
      call(
        fetchTimelineEntries,
        from,
        to,
        ContractTimelineEntryType.ClientContractPeriod,
        append,
        referenceDate,
      ),
    );
  }

  if (companySettings.ScheduleTemplates) {
    calls.push(
      call(
        fetchTimelineEntries,
        from,
        to,
        AircraftTimelineEntryType.ScheduleTemplate,
        append,
        referenceDate,
      ),
    );
  }

  if (companySettings?.Enable722CARValidation) {
    calls.push(call(fetchExtensionPeriodEntries));
  }

  yield all(calls);
}
